// `sage preset` installed this file automatically.
// Running `sage preset` again could result in automatic deletion of this file.
// Because of this, we do not recommend editing this file.
import 'bootstrap';



// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js